export const REQUEST_COMPANIES = 'REQUEST_COMPANIES';
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
export const REQUEST_SEGMENTS = 'REQUEST_SEGMENTS';
export const RECEIVE_SEGMENTS = 'RECEIVE_SEGMENTS';
export const SET_COUNTRY_FILTER = 'SET_COUNTRY_FILTER';
export const SET_SEGMENT_FILTER = 'SET_SEGMENT_FILTER';
export const CLEAR_COUNTRY_FILTER = 'CLEAR_COUNTRY_FILTER';
export const CLEAR_SEGMENT_FILTER = 'CLEAR_SEGMENT_FILTER';
export const SET_SEARCH = 'SET_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const COMPANIES_PAGE_COUNT = 20;
